import { render, staticRenderFns } from "./MaxHeight.vue?vue&type=template&id=24832c8f&"
import script from "./MaxHeight.vue?vue&type=script&lang=js&"
export * from "./MaxHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports